import React from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import WorkflowPath from "./WorkflowPath";
import Reveal, { SplitTitle } from "../ui/Reveal";
import DirArrow from "../ui/DirArrow";
import useLang from "../../hooks/useLang";

// How We Work: the lit 12-step path with client checkpoints.
const HowWeWorkSection = () => {
  const { t } = useLang();
  const steps = t("howWeWork.steps", { returnObjects: true });

  return (
    <section id="how-we-work" className="py-16 sm:py-20 bg-paper scroll-mt-[72px]">
      <div className="container-site">
        <Reveal className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-8">
          <div className="max-w-3xl">
            <span className="eyebrow text-rose-dark">{t("howWeWork.badge")}</span>
            <SplitTitle text={t("howWeWork.title")} className="h-section text-ink mt-4" />
            <p className="lead text-zinc-500 mt-5">{t("howWeWork.intro")}</p>
          </div>
          <div className="flex flex-wrap items-center gap-5 self-start lg:self-auto">
            <Link to="/contact?mode=call" className="link-arrow group text-rose-dark hover:text-rose">
              <CalendarClock size={16} /> {t("cta.bookCall")}
            </Link>
            <Link to="/contact" className="btn-rose group">
              {t("cta.button")} <DirArrow nudge size={15} />
            </Link>
          </div>
        </Reveal>
        <WorkflowPath
          steps={t("howWeWork.flow.steps", { returnObjects: true })}
          phases={steps.map((step) => step.phase)}
          checkpoints={t("howWeWork.flow.checkpoints", { returnObjects: true })}
          replayLabel={t("howWeWork.flow.replay")}
          hint={t("howWeWork.flow.hint")}
        />
      </div>
    </section>
  );
};

export default HowWeWorkSection;
